import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Home, Briefcase, ClipboardList, Wallet, Bell, User, LogOut,
  ChevronRight, ShieldCheck, HelpCircle, Settings, Crown, Star, CreditCard
} from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../../../../assets/css/components/serviceprovider/dashboard/workernavbar/WorkerNavbar.css';
import logo from '../../../../assets/images/logoo.jpg';
import KycRequiredModal from '../kycrequired/KycRequiredModal';
import AppContext from '../../../../context/AppContext';
import echo from '../../../../config/echo';


const SIDEBAR_ITEMS = [
  { label: 'Home', path: '/worker-dashboard', icon: <Home size={20} /> },
  { label: 'My Jobs', path: '/bid-jobs', icon: <Briefcase size={20} /> },
  // { label: ' Bookings',      path: '/worker-booking',       icon: <ClipboardList size={20}/> },
  { label: 'Earnings', path: '/worker-earnings', icon: <Wallet size={20} /> },
  { label: 'Notifications', path: '/worker-notifications', icon: <Bell size={20} /> },
  { label: 'Profile', path: '/worker-profile', icon: <User size={20} /> },
  { label: 'FAQs', path: '/worker-faq', icon: <HelpCircle size={20} /> },
  { label: 'KYC', path: '/worker-kyc', icon: <ShieldCheck size={20} /> },
  { label: 'Subscription', path: '/subscription-history', icon: <Crown size={20} /> },
  { label: 'Help & Support', path: '/worker-support', icon: <HelpCircle size={20} /> },
  { label: 'Settings', path: '/worker-settings', icon: <Settings size={20} /> },
    // { label: 'Payment Method', path: '/payment-cards', icon: <CreditCard size={20} /> },
]



const WorkerSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authToken, setAuthToken, kycStatus, setKycStatus, baseUrl, baseUrlForFile, workerProfile, setWorkerProfile, dashboardData,
  } = useContext(AppContext);
const [showKycModal, setShowKycModal] = useState(false);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [rating, setRating] = useState('');
  const [ProfileImage, setProfileImage] = useState(null);
  const [loggedInWorker, setLoggedInWorker] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  const ProtectedWorkerRoute = ({ children }) => {
    const { kycStatus } = useContext(AppContext);

    if (kycStatus !== "approved") {
      return <navigate to="/worker-kyc" replace />;
    }

    return children;
  };

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');

    if (!authToken) return;

    axios.get(`${baseUrl}/worker/viewkyc`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then(res => {
        const kyc = res.data.kyc;
        setKycStatus(kyc ? kyc.status : 'not_submitted');
      })
      .catch(() => {
        setKycStatus('not_submitted');
      });

  }, [baseUrl]);
// useEffect(() => {

//     const token = localStorage.getItem("authToken");

//     if (!token) return;

//     axios.get(`${baseUrl}/worker/viewProfile`, {
//         headers: {
//             Authorization: `Bearer ${token}`
//         }
//     })
//     .then((res) => {

//         console.log(res.data);

//         setWorkerProfile(res.data.serviceprovider);

//     })
//     .catch((err) => {
//         console.log(err);
//     });

// }, []);
  const protectedRoutes = [
  
    '/bid-jobs',
    '/worker-earnings',
    '/worker-notifications',
    '/subscription-history',
    '/worker-support',
  
  ];

 const handleNav = (path) => {

  if (
    kycStatus !== "approved" &&
    protectedRoutes.includes(path)
  ) {
    setShowKycModal(true);
    return;
  }

  navigate(path);
};

  const isActive = (path) =>
    path === '/worker-dashboard'
      ? location.pathname === '/worker-dashboard'
      : location.pathname.startsWith(path);

  useEffect(() => {
    console.log("Worker Profile:", workerProfile);

    if (workerProfile) {
      setFullName(workerProfile.fullName || "");
      setEmail(workerProfile.email || "");
      setProfileImage(workerProfile.ProfileImage || "");
      setRating(workerProfile.rating || 0);
    }
  }, [workerProfile]);


  useEffect(()=>{


const getUnreadCount=()=>{

axios.get(
`${baseUrl}/worker/unread/count`,
{
headers:{
Authorization:`Bearer ${authToken}`
}
}
)
.then(res=>{

setUnreadCount(res.data.count);

})
.catch(err=>{
console.log(err);
})


}


getUnreadCount();


const interval=setInterval(getUnreadCount,10000);


return ()=>clearInterval(interval);


},[]);


// useEffect(() => {
//     const workerId = workerProfile?.id;

//     if (!workerId) return;

//     const channelName = `worker-${workerId}`;

//     console.log("WorkerNavbar subscribing:", channelName);

//     const channel = echo.channel(channelName);

//     channel.listen('.NotificationUpdates', (event) => {
//         console.log("New Notification:", event);

//         setUnreadCount(prev => prev + 1);
//     });

//     return () => {
//         console.log("WorkerNavbar leaving:", channelName);

//         echo.leave(channelName);
//     };

// }, [workerProfile?.id]);



const SIDEBAR_ITEMS = [
  { label: 'Home', path: '/worker-dashboard', icon: <Home size={20} /> },
  { label: 'My Jobs', path: '/bid-jobs', icon: <Briefcase size={20} /> },
  // { label: ' Bookings',      path: '/worker-booking',       icon: <ClipboardList size={20}/> },
  { label: 'Earnings', path: '/worker-earnings', icon: <Wallet size={20} /> },
{ 
 label: 'Notifications', 
 path: '/worker-notifications', 
 icon: 
 <div className="bell-wrapper">
   <Bell size={20}/>
   {
    unreadCount > 0 &&
  <span className="notification-count">
 {unreadCount > 99 ? "99+" : unreadCount}
</span>
   }
 </div>
}, 
 { label: 'Profile', path: '/worker-profile', icon: <User size={20} /> },
  { label: 'FAQs', path: '/worker-faq', icon: <HelpCircle size={20} /> },
  { label: 'KYC', path: '/worker-kyc', icon: <ShieldCheck size={20} /> },
  { label: 'Subscription', path: '/subscription-history', icon: <Crown size={20} /> },
  { label: 'Help & Support', path: '/worker-support', icon: <HelpCircle size={20} /> },
  { label: 'Settings', path: '/worker-settings', icon: <Settings size={20} /> },
    // { label: 'Payment Method', path: '/payment-cards', icon: <CreditCard size={20} /> },

];

  return (
    <>
    <aside className="ws-sidebar">
      <div className="ws-profile" onClick={() => navigate('/worker-profile')}>
       <img
    src={
        workerProfile?.ProfileImage
            ? `${baseUrlForFile}/storage/${workerProfile.ProfileImage}`
            : logo
    }
    className="ws-profile-img"
    alt="Profile"
/>
        {/* <div className="ws-profile-info">
          <span className="ws-profile-name">{workerProfile?.fullName}</span>
          <span className="ws-profile-email">{workerProfile?.email}</span>
          <span className="ws-profile-rating">
            <Star size={13} fill="#f59e0b" color="#f59e0b" />
            {workerProfile?.rating}
          </span>
        </div> */}
      </div>

      <nav className="ws-nav">
        {SIDEBAR_ITEMS.map(item => (
          <button key={item.path}
            className={"ws-nav-item " + (isActive(item.path) ? 'ws-nav-item--active' : '')}
            onClick={() => handleNav(item.path)}>
            <span className="ws-nav-icon">{item.icon}</span>
            <span className="ws-nav-label">{item.label}</span>
            {isActive(item.path) && <ChevronRight size={15} className="ws-nav-chevron" />}
          </button>
        ))}
      </nav>

      <div className="ws-sidebar-footer">
        <button className="ws-logout-btn" onClick={() => navigate('/')}>
          <LogOut size={18} /><span>Logout</span>
        </button>
      </div>
    </aside>
    
  <KycRequiredModal
  isOpen={showKycModal}
  onClose={() => setShowKycModal(false)}
  onCompleteKyc={() => {
    setShowKycModal(false);
    navigate("/worker-kyc");
  }}
/>
</>
);
};

export default WorkerSidebar;